import { useEffect, useState } from 'react';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import { useParams } from 'react-router-dom';
import { API_ASSET_MAPING_CONFIG_PUT } from '../../constants';
import { SolutionMappingConfigItem } from '../../types';
import solutionsStore, {
  useCurrentSolutionName,
  useSolutionDetails,
} from '../../redux';
import SolutionMappingEditModal from './SolutionMappingEditModal';

type Props = {
  item: SolutionMappingConfigItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionMappingEditContainer({ item, open, onClose }: Props) {
  const { solutionId } = useParams();
  const solutionName = useCurrentSolutionName();
  const { showAlert } = useAlert();
  const actions = useStoreUnitActions(solutionsStore);
  const [solutionDetails] = useSolutionDetails();
  const isISA95Standard =
    solutionDetails?.isIsa95Standard || false;

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generateApiPath(API_ASSET_MAPING_CONFIG_PUT, {
          solutionId,
          siteId: !isISA95Standard ? '00' : item?.siteId,
          twinId: item?.twinId,
          mappingId: item?.id,
        }),
        params,
      }),
    () => {
      showAlert({
        type: AlertType.Info,
        title: 'Digital Twin Configuration Modified',
        text: ` Digital Twin Configuration modified successfully`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.assetMappingConfig({
        solutionId,
        siteId: item?.siteId,
        twinId: item?.twinId,
        mappingId: item?.id,
      });
    }
  );

  return (
    <SolutionMappingEditModal
      item={item}
      title={'Edit Digital Twin Configuration'}
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      confirmBtnText={'Save'}
      loading={loading}
    />
  );
}

export default SolutionMappingEditContainer;
